:host {
  --label-width-percentage: 40%;
  --value-width-percentage: 60%;
  --padding-value: calc(var(--spacer) * 3);
}

:host([clampLine]) {
  .labeled-content {
    .content-label {
      align-self: baseline;
    }

    .content-value {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-word;
    }
  }
}

.labeled-content {
  display: flex;
  flex-direction: row;
  margin-bottom: var(--spacer);
  &.label-mw-250 {
    .content-label {
      width: 250px;
      padding-right: calc(var(--spacer) * 3);
    }
    .content-value {
      padding-left: 0;
      width: calc(100% - 250px);
    }
  }

  .content-label {
    width: var(--label-width-percentage);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: var(--padding-content-label);

    gz-tooltip {
      width: 100%;
    }
  }
  .content-value {
    width: var(--value-width-percentage);
    padding-left: var(--padding-value);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--main-titles-inputs-600);
  }

  &.stacked {
    flex-direction: column;

    .content-label,
    .content-value {
      width: 100%;
    }
    .content-value {
      padding-left: 0;
      padding-top: 10px;
    }
  }
}

